import { Children, ReactElement } from "react"

import { isNil } from "@izettle/react"

import {
  DropdownChildren,
  DropdownValue,
  OptionProps,
  OptionPropsWithChildren,
} from "../types"

export const getPropsFromChildrenOptions = (elements: DropdownChildren) => {
  const props = Children.map<
    OptionPropsWithChildren,
    ReactElement<OptionPropsWithChildren>
  >(
    elements as ReactElement<OptionPropsWithChildren>,
    ({ props: childProps }) => childProps,
  )

  return isNil(props) ? [] : props
}

export const filterSelectedOptions = (
  dropdownValue: DropdownValue[],
  options: OptionPropsWithChildren[],
) =>
  options.filter(
    ({ overrideIsSelected, value }) =>
      overrideIsSelected ?? dropdownValue.includes(value),
  )

export const getIsOptionSelectedByProps = (
  selected: OptionProps[],
  option: OptionProps,
) => {
  const { overrideIsSelected, value } = option

  return overrideIsSelected ?? selected.some((item) => item.value === value)
}

export const castValueToArray = (
  value: undefined | DropdownValue | DropdownValue[],
  isMultiple: boolean,
) => {
  if (isMultiple) {
    return isNil(value) ? [] : (value as DropdownValue[])
  }

  return [value]
}

export const toggleArrayItem = (source: any[], item: any) => {
  const arrayClone = [...source]
  const itemIndex = arrayClone.indexOf(item)

  itemIndex === -1 ? arrayClone.push(item) : arrayClone.splice(itemIndex, 1)

  return arrayClone
}
